import React from "react";

import DownloadMessage from "./DownloadMessage";

const DownloadMessagePublicDomain = () => (
    <DownloadMessage>Public Domain, free to use</DownloadMessage>
);

export default DownloadMessagePublicDomain;
